import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {HPV_TEST_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/hpv-test/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/hpv-test/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/hpv-test/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/hpv-test/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/hpv-test/Questionnaire5Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const HPVTest = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case HPV_TEST_KEYS.START:
        trackPageViewGA('/hpv-test/start', 'MDQ-HPV Test - Start');
        return <Questionnaire1Screen />;
      case HPV_TEST_KEYS.PROFILE:
        trackPageViewGA('/hpv-test/profile', 'MDQ-HPV Test - Profile');
        return <Questionnaire2Screen />;
      case HPV_TEST_KEYS.INVALID:
        trackPageViewGA('/hpv-test/invalid', 'MDQ-HPV Test - Invalid');
        return <Questionnaire3Screen />;
      case HPV_TEST_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA('/hpv-test/appointment-preferences', 'MDQ-HPV Test - Appointment Preferences');
        return <Questionnaire4Screen />;
      case HPV_TEST_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA('/hpv-test/your-test-package', 'MDQ-HPV Test - Your Test Package');
        return <Questionnaire5Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default HPVTest;
